import { api, dispatcher } from '@unicus/react-ui-kit';

export const STATISTICS_GET = 'STATISTICS_GET';
export const STATISTICS_GET_FINISHED = 'STATISTICS_GET_FINISHED';

export const STATISTICS_USER_GET = 'STATISTICS_USER_GET';
export const STATISTICS_USER_GET_FINISHED = 'STATISTICS_USER_GET_FINISHED';

export const STATISTICS_GET_PRODUCTIVITY = 'STATISTICS_GET_PRODUCTIVITY';
export const STATISTICS_GET_PRODUCTIVITY_FINISHED =
  'STATISTICS_GET_PRODUCTIVITY_FINISHED';

export const STATISTICS_GET_STEPS = 'STATISTICS_GET_STEPS';
export const STATISTICS_GET_STEPS_FINISHED = 'STATISTICS_GET_STEPS_FINISHED';

export const STATISTICS_GET_ATTENDANCES_IN_PROGRESS =
  'STATISTICS_GET_ATTENDANCES_IN_PROGRESS';
export const STATISTICS_GET_ATTENDANCES_IN_PROGRESS_FINISHED =
  'STATISTICS_GET_ATTENDANCES_IN_PROGRESS_FINISHED';

export const get = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'statistics',
    actionType: STATISTICS_GET,
    effect: async () => api.fetch(`statistics`, { ...params })
  });
};

export const getMonthlyProductivity = (params = {}) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'statistics',
    actionType: STATISTICS_GET_PRODUCTIVITY,
    effect: async () =>
      api.fetch(`statistics/monthly-productivity`, { ...params })
  });
};

export const getAttendanceInProgress = (params = {}) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'statistics',
    actionType: STATISTICS_GET_ATTENDANCES_IN_PROGRESS,
    effect: async () => api.fetch(`statistics/attendance-in-progress`, params)
  });
};
